// ==========================================
// Header.jsx - Top Branding with Logo
// ==========================================

import React from "react";
import styles from "../assets/styles/Header.module.css";
import logo from "../assets/images/formforge_logo.png"; // Ensure the path is correct

function Header() {
  return (
    <header className={styles.header}>
      <div className={styles.logoTitle}>
        <img src={logo} alt="FormForge Logo" className={styles.logo} />
        <div>
          <h1 className={styles.title}>FormForge Tex</h1>
          <p className={styles.tagline}>AI-based Form Generation Platform</p>
        </div>
      </div>
    </header>
  );
}

export default Header;
